import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Panel } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export function DeleteAccountPanel() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/me/delete", { password });
      toast.success(data.company_deleted ? "Account e azienda eliminati" : "Account eliminato");
      logout();
    } catch (e2) {
      toast.error(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Panel title="Elimina account" testId="delete-account-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 p-5">
        <p className="max-w-md text-sm text-muted-foreground">Elimina definitivamente il tuo account con ferie, permessi, malattie, notifiche e allegati. L'operazione non si può annullare.{user?.role === "admin" && " Se sei l'unico amministratore e in azienda non c'è nessun altro, verrà eliminata anche l'azienda."}</p>
        <Button variant="destructive" onClick={() => setOpen(true)} data-testid="delete-account-button"><Trash2 className="mr-1.5 h-4 w-4" />Elimina account</Button>
      </div>
      <Dialog open={open} onOpenChange={(o) => { setOpen(o); setPassword(""); }}>
        <DialogContent className="max-w-md" data-testid="delete-account-dialog">
          <DialogHeader>
            <DialogTitle>Eliminare il tuo account?</DialogTitle>
            <DialogDescription>Inserisci la tua password per confermare. Tutti i tuoi dati verranno cancellati.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <div className="space-y-1.5"><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" data-testid="delete-account-password-input" /></div>
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setOpen(false)} data-testid="delete-account-cancel">Annulla</Button>
              <Button type="submit" variant="destructive" disabled={busy || !password} data-testid="delete-account-confirm">Elimina definitivamente</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </Panel>
  );
}
